<template>
  <!-- eslint-disable -->
<v-container fluid id="userEvents">
<v-slide-y-transition mode="out-in">
  <div>
    <h1>User Events</h1>
    <div>
      <v-layout wrap>
          <v-flex id="time-picker-menu">
            <v-menu :close-on-content-click="false" v-model="timePickerStartMenu" :nudge-right="40" transition="scale-transition" offset-y  max-width="290px" min-width="290px" >
              <template v-slot:activator="{ on }">
                <v-text-field id="time-picker-text" v-on="on" v-model="timePickerStart" :rules="[rulesRequired]" label="Start Date" hint="YYYY-MM-DD format" persistent-hint prepend-icon="event" readonly ></v-text-field>
              </template>
              <v-date-picker id="time-picker-calendar" v-model="timePickerStart" no-title @input="timePickerStartMenu = false" ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex id="time-picker-menu">
            <v-menu  :close-on-content-click="false" v-model="timePickerEndMenu" :nudge-right="40" transition="scale-transition" offset-y  max-width="290px" min-width="290px" >
              <template v-slot:activator="{ on }">
                <v-text-field id="time-picker-text" v-on="on" v-model="timePickerEnd" :rules="[rulesRequired]" label="End Date" hint="YYYY-MM-DD format" persistent-hint prepend-icon="event" readonly ></v-text-field>
              </template>
              <v-date-picker id="time-picker-calendar" :min="timePickerStart" v-model="timePickerEnd" no-title @input="timePickerEndMenu = false" ></v-date-picker>
            </v-menu>
          </v-flex>  
       </v-layout>
      <v-select :items="Events"  v-model="selectedEvents" prepend-icon="filter_list" multiple label="Events" single-line :append-icon="selectedEvents.length == 0 ? '' : 'clear'" @click:append="() => {selectedEvents = [];}"></v-select>
      <v-select :items="Problems" item-text="Label" item-value="Code"   v-model="selectedProblems" prepend-icon="filter_list" multiple label="Problems" single-line :append-icon="selectedProblems.length == 0 ? '' : 'clear'" @click:append="() => {selectedProblems = [];}"></v-select>
      <v-select :items="States" label="States"  v-model="selectedStates" prepend-icon="filter_list" multiple single-line :append-icon="selectedStates.length == 0 ? '' : 'clear'" @click:append="() => {selectedStates = [];}"></v-select>
      <v-textarea filled name="User Names" hide-details style="padding-top: 15px;" placeholder="User Names" rows="3" validate-on-blur l v-model="userEmails" ></v-textarea>
    </div>

    <div>
      <v-btn  small class="submitHours" style="margin: 15px;" @click="loadUserEvents()">
        Submit
      </v-btn>

      <v-btn class="close-btn" v-if="userEvents.length > 0" small @click="createEventFile" style="margin: 15px;" :disabled="fetchingExcelDoc">
        Download Excel Sheet
      </v-btn>
      <v-btn class="close-btn" v-if="userEvents.length > 0" small @click="showEmailDialog = true" style="margin: 15px;" >
        Send Email     
      </v-btn>
      
    </div>

    <v-data-table :mobile-breakpoint="0" :items-per-page.sync="rowsPerPage" :footer-props="{'items-per-page-options': [100,250,500]}" :loading="loadingEvents" class="flightTable no-wrap-th" :items="userEvents" item-key="Flight" :headers="headers">
      <template v-slot:item="{ item }" item-key="HashKey">
        <tr>
          <td>{{item.UserName}}</td>
          <td>{{item.Event}}</td>
          <td>{{item.Details}}</td>
          <td>{{item.Problem}}</td>
          <td>{{item.State}}</td>
          <td>{{formatDate(item.DateCreatedUtc)}}</td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog v-model="showFilter" max-width="500px">
      <v-card>
          <v-card-title>
            <span class="headline">Filter Events</span>
          </v-card-title>
          <div style="padding: 0 25px;">
              
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" class="cancel-add-btn" text @click="showFilter = false">Close</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showEmailDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Send Event Spreadsheet to Email</span>
        </v-card-title>
        <v-card-text style="padding-top: 0;">
          <v-container grid-list-md style="padding-top: 0;">
            <v-form v-model="validForm" ref="form" lazy-validation>
              <v-text-field  v-model="sendEmail" :rules="[rulesRequired, rulesEmail]" append-icon="email" label="Email" single-line hide-details></v-text-field>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" :disabled="!validForm || sendingEmail" class="cancel-add-btn" text @click="emailEventFile">
            <span v-if="sendingEmail">Sending</span>
            <span v-else>Send</span>
          </v-btn>
          <v-btn color="blue darken-1" :disabled="sendingEmail" class="cancel-add-btn" text @click="showEmailDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</v-slide-y-transition>
  </v-container>
<!-- eslint-enable -->
</template>
<script>
import phoneConfigModule, {
  PHONE_CONFIG_NAMESPACE
} from "./store/phoneConfigStore";
import { mapGetters } from "vuex";
import moment from "moment";
import RulesMixin from "@/mixins/RulesMixin.js";

export default {
  name: "UserEvents",
  mixins: [RulesMixin],
  data() {
    return {
      States: [
        "CANCELED",
        "COMPLETE",
        "ESCALATED",
        "STARTED",
        "PAUSED",
        "OPEN",
        "ERROR"
      ],
      Problems: [
        {
          Code: "CD",
          Label: "CD: Customs Delay"
        },
        {
          Code: "CMD",
          Label: "CMD: Carrier Mis-sort Delay"
        },
        {
          Code: "CNA",
          Label: "CNA: Customer Not Available"
        },
        {
          Code: "CPU",
          Label: "CPU: Customer Pickup"
        },
        {
          Code: "CSR-COURIER",
          Label: "CSR-COURIER: Courier Request"
        },
        {
          Code: "CSR-CPU",
          Label: "CSR-CPU: Customer Pickup Request"
        },
        {
          Code: "CSR-REDELIVER",
          Label: "CSR-REDELIVER: Redelivery Request"
        },
        {
          Code: "CSR-REDIRECT",
          Label: "CSR-REDIRECT: Redirect Request"
        },
        {
          Code: "CSR-RRT",
          Label: "CSR-RRT: Requested Reattempt Today"
        },
        {
          Code: "CSR-RTS",
          Label: "CSR-RTS: Requested Return To Sender"
        },
        {
          Code: "CSR-SAT",
          Label: "CSR-SAT: Saturday Delivery Upgrade Request"
        },
        {
          Code: "CSR-SIG",
          Label: "CSR-SIG: Requested Remove Signature Requirement"
        },
        {
          Code: "CSR-TRACE",
          Label: "CSR-TRACE: Requested Trace"
        },
        {
          Code: "DIA",
          Label: "DIA: Delivered to Incorrect Address"
        },
        {
          Code: "EDC",
          Label: "EDC: Exceeded Delivery Commitment"
        },
        {
          Code: "EOD",
          Label: "EOD: End of Day"
        },
        {
          Code: "IA",
          Label: "IA: Incorrect Address"
        },
        {
          Code: "IPN",
          Label: "IPN: Incorrect Phone Number"
        },
        {
          Code: "LST",
          Label: "LST: Lost"
        },
        {
          Code: "MNS",
          Label: "MNS: Manifested Not Shipped"
        },
        {
          Code: "MON-CPU",
          Label: "MON-CPU: Monitored Customer Pickup"
        },
        {
          Code: "NSD",
          Label: "NSD: No Scheduled Delivery"
        },
        {
          Code: "REF",
          Label: "REF: Refused"
        },
        {
          Code: "RSD",
          Label: "RSD: Carrier Rescheduled Delivery"
        },
        {
          Code: "RTS",
          Label: "RTS: Return to Sender"
        },
        {
          Code: "SDD",
          Label: "SDD: Detected Delay"
        },
        {
          Code: "UNK",
          Label: "UNK: Unknown"
        },
        {
          Code: "WEC",
          Label: "WEC: Weather Extreme Condition"
        }
      ],
      Events: [
        "LOGIN",
        "LOGOUT",
        "PAUSED",
        "TASK_START",
        "TASK_COMPLETE",
        "TASK_INCOMPLETE",
        "CALL_INCOMING",
        "CALL_START",
        "CALL_END",
        "WORK_START",
        "SEARCH",
        "PARAMETER_ADDED"
      ],
      loadingEvents: false,
      rowsPerPage: 100,
      validForm: true,
      sendingEmail: false,
      sendEmail: "",
      showEmailDialog: false,

      userEmails: "",
      selectedEvents: [],
      selectedProblems: [],
      selectedStates: [],

      showFilter: false,
      fetchingExcelDoc: false,
      timePickerStartMenu: false,
      timePickerStart: moment(Date.now())
        .add(0, "d")
        .format("YYYY-MM-DD"),
      timePickerEndMenu: false,
      timePickerEnd: moment(Date.now()).format("YYYY-MM-DD"),
      headers: [
        {
          text: "UserName",
          sortable: true,
          align: "left",
          value: "UserName"
        },
        {
          text: "Event",
          sortable: true,
          align: "left",
          value: "Event"
        },
        {
          text: "Details",
          sortable: true,
          align: "left",
          value: "Details"
        },
        {
          text: "Problem",
          sortable: true,
          align: "left",
          value: "Problem"
        },
        {
          text: "State",
          sortable: true,
          align: "left",
          value: "State"
        },
        {
          text: "DateCreatedUtc",
          sortable: true,
          align: "left",
          value: "DateCreatedUtc"
        }
      ]
    };
  },
  computed: {
    ...mapGetters(PHONE_CONFIG_NAMESPACE, ["userEvents"])
  },
  created: /* istanbul ignore next */ function() {
    this.$registerVuexModule(PHONE_CONFIG_NAMESPACE, phoneConfigModule);
    this.$isInRole([this.$roleDefs.ADMIN, this.$roleDefs.PHONES_ADMIN]).then(
      res => {
        if (res) {
        } else this.$goHome();
      }
    );
  },
  methods: {
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    loadUserEvents() {
      this.loadingEvents = true;
      var end = moment(this.timePickerEnd).add(1, "d");
      var usernames = [];
      if (this.userEmails.trim() != "")
        usernames = _.map(this.userEmails.split(","), _.trim);
      return this.$store
        .dispatch(`${PHONE_CONFIG_NAMESPACE}/loadUserEvents`, {
          StartDate: moment(this.timePickerStart),
          EndDate: moment(end),
          UserNameList: usernames,
          EventList: this.selectedEvents,
          ProblemList: this.selectedProblems,
          StateList: this.selectedStates
        })
        .then(x => {
          this.loadingEvents = false;
        });
    },
    createEventFile() {
      this.fetchingExcelDoc = true;
      return this.$store
        .dispatch(`${PHONE_CONFIG_NAMESPACE}/createEventFile`, this.userEvents)
        .then(value => {
          this.fetchingExcelDoc = false;
          var binaryString = window.atob(value);
          var binaryLen = binaryString.length;
          var bytes = new Uint8Array(binaryLen);
          for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
          }
          var blob = new Blob([bytes], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          var fileName = `User Events ${moment(this.timePickerStart).format(
            "YYYY_MM_DD"
          )}-${moment(this.timePickerEnd).format("YYYY_MM_DD")}.xlsx`;
          link.download = fileName;
          link.click();
        });
    },
    emailEventFile() {
      if (this.$refs.form.validate()) {
        return this.$store
          .dispatch(`${PHONE_CONFIG_NAMESPACE}/emailEventFile`, {
            Email: this.sendEmail,
            AttachmentName: `User Events ${moment(this.timePickerStart).format(
              "YYYY_MM_DD"
            )}-${moment(this.timePickerEnd).format("YYYY_MM_DD")}`,
            Events: this.userEvents
          })
          .then(x => {
            this.sendingEmail = false;
            this.showEmailDialog = false;
            this.sendEmail = "";
          });
      }
    }
  }
};
</script>
